<template>
  <div class="qn-container">
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <div class="qn-card" :style="{backgroundColor: `${row.bgColor4} !important`}">
              <img :src="require('../../assets/ami/quality.svg')" class="img-fluid" alt="" />
              <div class="qn-details">
                <div class="bg-title white-color" v-html="row.title4"></div>
                <div class="text white-color" v-html="row.body4"></div>
                <router-link v-if="row.button4" :to="row.redirect4" class="qn-btn d-inline-block">
                  <div class="d-flex align-items-center">
                    <span v-html="row.button4"></span>
                    <span class="icon-back icon"></span>
                  </div>
                </router-link>
              </div>
          </div>
        </div>

        <div class="col-lg-6">
          <div class="qn-card d-block" :style="{backgroundColor: `${row.bgColor5} !important`}">
              <!-- <div class="sub-title" :style="{color: '#001774'}">News</div> -->
              <div class="n-title" v-html="row.title5"></div>
              <div class="newsletter d-flex">
                <input type="text" class="input-news" placeholder="Your mail here " />
                <button class="subscribe-btn">
                  <div class="d-flex align-items-center">{{ row.button5 }} <span class="icon-back icon"></span></div>
                </button>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.qn-container {
  padding: 50px 0;
}
.qn-card {
  padding: 50px;
  display: flex;
  height: 100%;
}
.qn-details {
  padding-top: 35px;
  padding-left: 20px;
}
.bg-title {
  font-size: 45px;
  margin-bottom: 13px;
}
.text {
  font-size: 17px;
  margin-bottom: 20px;
}
.qn-btn {
  border: 1px solid #fff;
  line-height: 1;
  padding: 8px 19px;
  color: #fff
}
.qn-btn:hover {
  background: #fff;
  color: #000;
}
.qn-btn .icon:before {
  font-weight: bold;
  color: #fff;
}
.qn-btn:hover .icon:before {
  color: #000;
}
.qn-btn:active {
  opacity: 0.6;
}
.sub-title {
  font-weight: bold;
  font-size: 22px;
  margin-bottom: 15px;
}
.n-title {
  font-weight: bold;
  font-size: 35px;
  line-height: 1;
  margin-bottom: 30px;
}
.input-news {
  background: #fff;
  padding: 7px 15px;
  width: calc(100% - 136.55px);
  border-radius: 0 !important;
}
.subscribe-btn {
  background: #099095;
  padding: 7px 20px;
  font-size: 17px;
  color: #fff;
}
.subscribe-btn .icon:before {
  color: #fff;
  font-weight: bold;
  font-size: 19px;
}
.subscribe-btn:hover {
  background: #06686c;
}
.subscribe-btn:active {
  opacity: 0.6;
}

/* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) {
    
}

@media (max-width: 767.98px) {
    .qn-card {
      padding: 40px 24px;
      margin-bottom: 30px;
      height: auto;
    }
    .qn-details {
      padding-top: 0;
    }
    .qn-card img {
      width: 77px;
    }
    .bg-title {
    font-size: 28px;
    margin-bottom: 5px;
  }
  .text {
    margin-bottom: 12px;
    font-size: 16px;
  }
  .qn-btn {
    padding: 6px 14px;
  }
  .subscribe-btn .icon {
    font-size: 15px;
  }
  .subscribe-btn {
    font-size: 15px;
    padding: 7px 16px
  }
  .input-news {
    width: calc(100% - 120px);
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) {
  .qn-details {
    padding-top: 10px;
  }
}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) {
  .qn-details {
    padding-top: 18px;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) {
  .bg-title {
    font-size: 33px;
    margin-bottom: 12px;
  }
  .qn-details {
    padding-top: 18px;
  }
  .text {
    margin-bottom: 15px;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {

}
</style>

<script>
import axios from "axios";
export default {
  name: "Section4",
  props: ['row'],
  components: {},
  data() {
    return {
      pgLoading: true,
      email: ''
    };
  },
  created() {
      //
  },
  methods: {
    newsletter() {
      const options = {
        url: window.baseURL + '/newsletters',
        method: "POST",
        data: {
          email: this.email
        },
      };

      axios(options)
        .then((res) => {
          console.log(res);
          this.email = "";
          alert(res.data.message);
        })
        .catch((err) => {
          console.log(err);
          alert(err.message);
        });
    }
  },
};
</script>
